// KPI Builder — the click-through list of a gap KPI ("who are these learners?").
// Shape of the existing “Not Completed Students – Detail” / “…Professionals – Detail” visualizations.
import { columnAggs } from './columns';
import { RecipeContext } from './queries';
import { isPreService } from './lookups';
import { DetailOutput, QueryObject } from './types';

const PRE_COLUMNS = ['name', 'district', 'instType', 'institute'];
const IN_COLUMNS = ['name', 'district', 'block', 'facility'];

/** Same two queries as the gap number, but the first list also returns each learner's columns. */
export function buildGapDetail(c: RecipeContext, queries: QueryObject[], title: string, queryString: (q: QueryObject[]) => string): DetailOutput {
  const ids = isPreService(c.a) ? PRE_COLUMNS : IN_COLUMNS;
  const cols = c.src.cols.filter((col) => ids.includes(col.id) && !col.pii);
  const [first, ...rest] = queries;
  const registered = first.aggrQuery.aggs.registeredUsersAgg;
  const rows = registered.aggs?.rows ?? {};
  const withColumns: QueryObject = {
    ...first,
    aggrQuery: { ...first.aggrQuery, aggs: { registeredUsersAgg: { ...registered, aggs: { rows: { ...rows, aggs: columnAggs(cols).sub } } } } },
  };
  const paths = queries.map((q) => Object.keys(q.aggrQuery.aggs)[0]);
  return {
    title: `${title} - Detail`,
    visualizationCode: c.code + 'Detail',
    chartType: 'notenrolleddetail',
    queryString: queryString([withColumns, ...rest]),
    config: {
      chartType: 'notenrolleddetail', valueType: 'number', isDecimal: false, action: '', filter: '', documentType: '_doc', drillChart: 'none',
      resultType: 'value', aggregationPaths: paths, detailColumns: cols.map((col) => col.label), excludeFirstColumn: true,
    },
  };
}
